module.exports = __webpack_public_path__ + "img/header_bg.f7a2e2f8.png";